(function ($) {
  /**
   * Multi Use Tout Video - v1
   */
  Drupal.behaviors.multiUseToutVideoV1 = {
    attach: function (context, settings) {
      // Set the inner caption to the height of the tout.
      var $multiUseToutVideo = $('.js-multi-use-tout-video', context);
      // As the video moves up 100px underneath to GNAV when the option "cut off video height" is enabled in CMS, dynamic height has been set here to remove extra sapce at the bottom of the video
      var cutOffVideoAdjustHeight = function ($this) {
        var $cutOffVideoSelector = $this.filter('.multi-use-tout-video__cut-off-height');

        if ($cutOffVideoSelector.length > 0) {
          $cutOffVideoSelector.closest('.node-elc-nodeblock').height($cutOffVideoSelector.height() - 100);
        }
      };
      var setCaptionInnerHeight = function () {
        $multiUseToutVideo.each(function () {
          $this = $(this);
          var thisHeight = $this.height();
          var $captionInner = $('.js-multi-use-tout-caption-inner', $this);

          $captionInner.height(thisHeight);
          cutOffVideoAdjustHeight($this);
        });
      };

      setCaptionInnerHeight();

      // Reapply on resize.
      $(window).resize(_.debounce(function () {
        setCaptionInnerHeight();
      }, 300));
      // Play video
      $multiUseToutVideo.each(function () {
        $this = $(this);
        var $videoSelector = $this.find('.js-video-banner-video');

        if ($videoSelector.length > 0) {
          var $video = $videoSelector[0];
          var $playIcon = $this.find('.js-multi-use-tout-play-icon');
          var $videoImage = $this.find('.js-multi-use-tout-video-image');
          var $videoText = $('.js-multi-use-tout-video-text');

          $videoText.click(function () {
            $video.play();
          });

          $playIcon.keyup(function (e) {
            if (site.getKeycode(e) === 13) {
              $playIcon.trigger('click');
            }
          });

          $playIcon.click(function () {
            if ($videoImage.length > 0) {
              $playIcon.addClass('hidden');
              $videoImage.addClass('hidden');
              $videoSelector.removeClass('hidden');
              $video.play();
            }
          });
          $video.onended = function () {
            if ($videoImage.length > 0) {
              $playIcon.removeClass('hidden');
              $videoImage.removeClass('hidden');
              $videoSelector.addClass('hidden');
            }
            $videoText.fadeIn(800);
          };
          $video.onplay = function () {
            $videoText.fadeOut(800);
          };
          $video.onloadeddata = function () {
            cutOffVideoAdjustHeight($this);
          };

          // Here screen.width is used to differentiate PC and iPad. should we use enquire.js like Origins?
          if ($this.find('.js-hide-video-controls').length && screen.width > 1024) {
            $videoSelector.prop('controls', false);
          }
        }
        cutOffVideoAdjustHeight($this);
      });
    }
  };
})(jQuery);
